import { useState, useEffect } from "react";
import { client } from "../sanity/client";

function Experience() {
  const [experiences, setExperiences] = useState([]);
  useEffect(() => {
    client
      .fetch(`*[_type == "experience"] | order(startDate desc)`)
      .then((data) => {
        setExperiences(data);
      });
  }, []);
  console.log(experiences);
  return (
    <>
      <p>
        <span className="prompt">ziad@portfolio:</span>
        <span className="path">~</span>
        <span className="command">$ cd professional experience</span>
      </p>

      <div className="section">
        {experiences[0]?.companies?.map(
          (
            exp,
            index, //doc theke companies array niye every company loop diye access korbe
          ) => (
            <div className="section" key={index}>
              {/* section banacchi ekta company er jonno ket={0} = Cefalo, key{2} = Vanilla */}
              <p>
                🌐 <span className="company">{exp.company}</span> — {exp.role}
                <br />
                <span className="work-date">
                  {exp.startDate} – {exp.endDate}
                </span>
              </p>

              {exp.points?.map((point, i) => (
                <p key={i}>→ {point}</p> // loop kore responsibilities pabo and seigulo P tag er vitor rekhe show korbo
              ))}
              <p>
                → <strong>Tech stack</strong>: {exp.techStack?.join(", ")}
              </p>
              {/* array theke React, Node.js, Sanity evabe show korbe */}
            </div>
          ),
        )}
      </div>
    </>
  );
}
export default Experience;
